(ns common.schema.editor-types)

(def text-like-editor-types
  #{:editor.type/text-simple
    :editor.type/textarea
    :editor.type/wysiwyg
    :editor.type/text-mention
    :editor.type/richtext-mention})

(def modal-editor-types
  #{:editor.type/textarea
    :editor.type/multi-select
    :editor.type/richtext-mention})

(defn text-like-editor-type?
  [editor-type]
  (contains? text-like-editor-types editor-type))

(defn modal-editor-type?
  [editor-type]
  (contains? modal-editor-types editor-type))
